import $ from "../lib/jquery.js";

/*
 * Thumbnail strip driving a stack of cross-fading full-size images.
 *
 * Expected markup (offsets are 0-based and must line up):
 *   .gallery-fader-thumbnails
 *     .gallery-fader-thumbnail > img#gallery-fade-thumbnail-N[data-offset=N]
 *   .gallery-fade-fullsize
 *     img#gallery-fade-fullsize-image-N.gallery-fade-fullsize-image
 */

const FADE_SPEED = 500;

export default function initGalleryFader() {
  const $gallery = $(".gallery-fade-fullsize");

  if (!$gallery.length) {
    return;
  }

  let current = 0;

  const $image = (offset) => $(`#gallery-fade-fullsize-image-${offset}`);
  const $thumb = (offset) => $(`#gallery-fade-thumbnail-${offset}`);

  function show(offset) {
    if (offset === current) {
      return;
    }

    // The easing means the pointer can move on before the fade finishes, so
    // hold the outgoing offset in a local rather than reading `current` later.
    const outgoing = current;
    current = offset;

    $thumb(outgoing).removeClass("active");
    $thumb(offset).addClass("active");

    $image(offset).css({ display: "block", zIndex: 3 }).stop().fadeTo(FADE_SPEED, 1);

    $image(outgoing)
      .css({ zIndex: 2 })
      .stop()
      .fadeTo(FADE_SPEED, 0, function fadedOut() {
        $(this).css({ display: "none", zIndex: 1 });
      });
  }

  // First image starts visible.
  $image(0).css({ display: "block", zIndex: 3 }).fadeTo(FADE_SPEED, 1);
  $thumb(0).addClass("active");

  $(".gallery-fader-thumbnail img").each((_, el) => {
    const offset = Number($(el).data("offset"));

    $(el)
      .on("click", () => show(offset))
      .on("mouseenter", () => $thumb(offset).addClass("active"))
      .on("mouseleave", () => {
        if (offset !== current) {
          $thumb(offset).removeClass("active");
        }
      });
  });
}
